// actions.js
import api from '../../config/base';
import { 
    FETCH_ROLES_REQUEST, 
    FETCH_ROLES_SUCCESS, 
    FETCH_ROLES_FAILURE,
    FETCH_ROLE_REQUEST, 
    FETCH_ROLE_SUCCESS, 
    FETCH_ROLE_FAILURE,
    CREATE_ROLE_REQUEST, 
    CREATE_ROLE_SUCCESS, 
    CREATE_ROLE_FAILURE,
    UPDATE_ROLE_REQUEST, 
    UPDATE_ROLE_SUCCESS, 
    UPDATE_ROLE_FAILURE,
    DELETE_ROLE_REQUEST, 
    DELETE_ROLE_SUCCESS, 
    DELETE_ROLE_FAILURE,
} from './types';

// Fetch roles
export const fetchRoles = () => async (dispatch) => {
    dispatch({ type: FETCH_ROLES_REQUEST });
    try {
        const response = await api.get('/roles');
        dispatch({ type: FETCH_ROLES_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_ROLES_FAILURE, payload: error.message });
    }
};

// Fetch a single role (if needed)
export const fetchRole = (id) => async (dispatch) => {
    dispatch({ type: FETCH_ROLE_REQUEST });
    try {
        const response = await api.get(`/roles/${id}`);
        dispatch({ type: FETCH_ROLE_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_ROLE_FAILURE, payload: error.message });
    }
};

// Create role
export const createRole = (role) => async (dispatch) => {
    dispatch({ type: CREATE_ROLE_REQUEST });
    try {
        const response = await api.post('/roles', role);
        dispatch({ type: CREATE_ROLE_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: CREATE_ROLE_FAILURE, payload: error.message });
    }
};

// Update role
export const updateRole = (id, role) => async (dispatch) => {
    dispatch({ type: UPDATE_ROLE_REQUEST });
    try {
        const response = await api.put(`/roles/${id}`, role);
        dispatch({ type: UPDATE_ROLE_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: UPDATE_ROLE_FAILURE, payload: error.message });
    }
};

// Delete role
export const deleteRole = (id) => async (dispatch) => {
    dispatch({ type: DELETE_ROLE_REQUEST });
    try {
        await api.delete(`/roles/${id}`);
        dispatch({ type: DELETE_ROLE_SUCCESS, payload: id });
    } catch (error) {
        dispatch({ type: DELETE_ROLE_FAILURE, payload: error.message });
    }
};
